export const PipelineTemplates = {};
